/*
 * Mur UGC — chargement différé des vignettes.
 * Extrait de sections/ugc-wall.liquid pour être mis en cache par le navigateur
 * au lieu d'être retéléchargé dans le HTML à chaque navigation.
 */
(function () {
  // Barre de progression : indique que la rangée défile et où on en est.
  // Masquée tant que le contenu tient dans la largeur disponible.
  function initProgress(section, grid) {
    var bar = section.querySelector('[data-ugc-progress]');
    if (!bar) return;
    var thumb = bar.querySelector('[data-ugc-progress-thumb]');
    if (!thumb) return;

    function update() {
      var overflow = grid.scrollWidth - grid.clientWidth;
      if (overflow <= 1) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var ratio = grid.clientWidth / grid.scrollWidth;
      thumb.style.width = ratio * 100 + '%';
      thumb.style.left = (grid.scrollLeft / grid.scrollWidth) * 100 + '%';
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initUgcWall(section) {
    var grid = section.querySelector('.ugc-wall__grid');
    if (!grid) return;

    initProgress(section, grid);

    var images = grid.querySelectorAll('.ugc-wall__img[data-src]');
    if (!images.length) return;

    function load(img) {
      if (!img || img.getAttribute('data-loaded')) return;
      img.setAttribute('data-loaded', '1');
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function loadAll() {
      Array.prototype.forEach.call(images, load);
    }

    // Éditeur de thème : tout charger, sinon le marchand voit des cases vides.
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      loadAll();
      return;
    }

    // 2e filtre : dans le carrousel, seules les vignettes réellement visibles
    // horizontalement (+ une d'avance) sont téléchargées.
    function observeTiles() {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            load(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { root: grid, rootMargin: '0px 300px' }
      );

      Array.prototype.forEach.call(images, function (img) {
        observer.observe(img);
      });
    }

    // 1er filtre : rien ne part tant que la section n'approche pas du viewport.
    var gate = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        gate.disconnect();
        observeTiles();
      },
      { rootMargin: '300px 0px' }
    );

    gate.observe(section);
  }

  function boot() {
    document.querySelectorAll('.ugc-wall-section').forEach(function (section) {
      if (section.dataset.ugcReady) return;
      section.dataset.ugcReady = '1';
      initUgcWall(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
